import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import RestrictedHtmlEditing from './restrictedhtmlediting';
import './restrictedhtmlstyle.css';
import RestrictedHtmlEditingCommand from './restrictedhtmlcommand';

export default class RestrictedHtml extends Plugin {
  static get requires() {
    return [ RestrictedHtmlEditing, RestrictedHtmlEditingCommand ];
  }

  static get pluginName() {
    return 'Restrictedhtml';
  }
}
